module.exports = __webpack_public_path__ + "img/everbloom-violet.7fc06ed8.webp";